import React, { useState, useEffect } from 'react';
import { Table, Popconfirm } from 'antd';

import { TableCol } from './getTableCol';

import { courseStruct } from './struct';
import { semesterLabel } from '../../../../../../../const/semesterLabel';

const { table } = courseStruct;

export const Course = ({ courses, semesterName, updateSemester, apaPoint, status }) => {

  const [_courses, setCourses] = useState(courses?.length > 0 ? courses : []);
  const handleCourses = (courses) => setCourses(courses);


  const handleSave = (row) => {
    const currentCourses = [..._courses];
    const index = currentCourses.findIndex((item) => item.key === row.key);

    currentCourses[index] = {
      ...currentCourses[index],
      ...row,
      modal: row.modal
    };


    handleCourses(currentCourses);
  };

  const handleDelete = (key) => {
    const newData = _courses.filter((item) => item.key !== key);
    handleCourses(newData);
  };


  const columns = [
    ...TableCol(handleSave, semesterName, status),
    {
      title: 'Action',
      dataIndex: 'operation',
      render: (_, record) => {
        const { key } = record;

        return (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(key)}
            disabled={status === 1 || status === 2 || status === 3}
          >
            <a>Delete</a>
          </Popconfirm>
        );
      }
    }
  ];

  useEffect(() => {
    updateSemester(semesterName, _courses);
  }, [_courses, semesterName]);

  return courses ? (
    <>
      <Table
        {...table}
        columns={columns}
        dataSource={_courses}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell colSpan={2} align='right' >
              Calculated APA score for the {semesterLabel(semesterName)} semester:
            </Table.Summary.Cell>
            <Table.Summary.Cell >{apaPoint}</Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
      <br />
    </>
  ) : (
    <></>
  );
};
